import * as React from 'react';
import {transparentize} from 'polished';
import styled from 'styled-components';
import Button, {ButtonVariant} from 'components/Button';
import Input from 'components/Input';
import {transition} from 'helpers/css';
import {CoursePromoContext} from '../context';


const Column = styled.div`
  margin-right: 30px;
  &:last-child {
    margin-right: 0;
    flex-grow: 1;
    max-width: 466px;
  }
`;

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: 1160px;

  @media screen and (max-width: 780px) {
    display: grid;
    grid-template-columns: 1fr;
    gap: 28px;
  }
`;

const Title = styled.div`
  font-size: 18px;
  font-weight: 600;
  line-height: 23px;
  margin-bottom: 25px;

  @media screen and (max-width: 780px) {
    margin-bottom: 16px;
  }
`;

const Link = styled.div`
  width: max-content;
  margin-bottom: 12px;
  padding-bottom: 2px;
  border-bottom: 1px solid transparent;
  font-size: 16px;
  font-weight: 500;
  line-height: 21px;
  
  color: ${({theme}) => `
    ${transparentize(.2, theme.variables.color)};
  `};
  
  cursor: pointer;
  
  ${transition()};
  
  &:hover {
    border-bottom: 1px solid white;
  }
`;

const Row = styled.div`
  display: grid;
  grid-template-columns: 1fr max-content;
  gap: 5px;
`;

const Agreement = styled.a`
  display: block;
  margin-top: 10px;
  font-size: 14px;
  line-height: 18px;
  color: ${({theme}) => `
    ${transparentize(.6, theme.variables.color)};
  `};
  
  ${transition()}
  
  &:hover {
    color: ${({theme}) => `
      ${transparentize(.15, theme.variables.color)};
    `};
  }
`;

const ButtonBox = styled.div`
  button {
    padding: 13px 20px;
  }
`;


/**
 * The returns course promo footer component
 * @return {React.ReactElement}
 * @constructor
 */
export default function Footer(): React.ReactElement {
  const context = React.useContext(CoursePromoContext);

  return (
    <Container>
      <Column>
        <Title>{context.title}</Title>
      </Column>
      <Column>
        <Title>Информация</Title>
        <Link>О школе</Link>
        <Link>Все курсы школы</Link>
      </Column>
      <Column>
        <Title>Получай уведомления о новых курсах школы</Title>
        <Row>
          <Input placeholder='Email'/>
          <ButtonBox>
            <Button variant={ButtonVariant.Primary}>Подписаться</Button>
          </ButtonBox>
        </Row>
        <Agreement href="https://www.google.com/" target="_blank">
          Нажимая на кнопку, я соглашаюсь на обработку персональных данных
        </Agreement>
      </Column>
    </Container>
  );
}
